import { Link } from 'react-router-dom'
import BigButton from '../components/BigButton'
import { eventDateSentence, useSeason } from '../lib/season'

export default function Reglement() {
  // De marktdag komt uit /beheer in plaats van hier hardgecodeerd te staan,
  // zodat deze pagina niet met september van vorig jaar blijft staan zodra
  // het seizoen in mei vanzelf heropent. Nog niet ingevuld = geen datum in
  // de kop, geen verkeerde.
  const { season } = useSeason()
  const datum = eventDateSentence(season)
  return (
    <>
      <section className="bg-lime border-b-[3px] border-ink">
        <div className="mx-auto max-w-5xl px-5 pt-10 pb-12">
          <p className="font-display text-xs sm:text-sm tracking-display uppercase text-ink/80">
            Rommelmarkt{datum ? ` · ${datum}` : ''}
          </p>
          <h1 className="mt-3 font-display text-7xl sm:text-9xl leading-[0.92] tracking-display uppercase">
            Reglement
          </h1>
          <p className="mt-5 text-lg max-w-2xl">
            Dit reglement is van toepassing op alle standhouders van de rommelmarkt van het Fluweelfeest.
            Wie zich inschrijft, aanvaardt dit reglement.
          </p>
        </div>
      </section>

      <section className="bg-offwhite border-b-[3px] border-ink">
        <div className="mx-auto max-w-5xl px-5 py-16 space-y-10">
          <Artikel n={1} titel="Organisatie">
            De rommelmarkt wordt jaarlijks georganiseerd door Fluweelfeest VZW op de zaterdag van het
            Fluweelfeest, in de straten rondom het festivalterrein — waaronder de Fluweelstraat,
            Kempstraat en Tortelduifstraat.
          </Artikel>

          <Artikel n={2} titel="Wie is standhouder?">
            Als standhouder wordt beschouwd: de persoon die één of meerdere plaatsen op zijn of haar naam
            reserveert en betaalt. De standhouder is verantwoordelijk voor de naleving van dit reglement voor
            alle plaatsen die op zijn of haar naam geregistreerd staan, ook wanneer die in eigen naam voor
            iemand anders werd ingeschreven.
          </Artikel>

          <Artikel n={3} titel="Inschrijven">
            <p>
              Wie een stand wil houden, schrijft zich in via de website. Om in te schrijven moet men minimum
              18 jaar oud zijn. Men kan bij inschrijving één tot vier plaatsen kiezen.
            </p>
            <p className="mt-3">
              Woon je in de Fluweelstraat, Kempstraat of Tortelduifstraat? Vink dan{' '}
              <em>buurtbewoner</em> aan en vul het adres van je gevel in. De organisatie reserveert de
              plek voor je gevel automatisch en geeft buurtbewoners voorrang tot en met 31 augustus.
            </p>
            <p className="mt-3">
              Woon je elders? Geef dan je gewenste straat door. Op 1 september sturen we een e-mail met
              de zone die we je toewijzen. Via de link in die mail kies je zelf je plek op de plattegrond.
              Na betaling is je inschrijving definitief. Bij niet-deelname of annulering is terugbetaling
              van het inschrijvingsgeld niet mogelijk.
            </p>
            <p className="mt-3">
              Wie zonder voorafgaande inschrijving een stand wil opzetten, richt zich op de dag zelf tot de
              organisatie. Bij beschikbare plaatsen wordt er een toegewezen; pas na betaling van het
              standgeld is men standhouder in de zin van artikel 2.
            </p>
          </Artikel>

          <Artikel n={4} titel="Prijs en plaatsbepaling">
            <p>
              Eén plaats is ongeveer 5 lopende meter en kost <strong>€5</strong>. Per inschrijving kunnen
              maximaal 4 plaatsen worden gereserveerd. De inschrijving is pas definitief na ontvangst van de
              betaling.
            </p>
            <p className="mt-3">
              Betalen kan via bankoverschrijving met de gestructureerde mededeling uit de bevestigingsmail,
              of door de QR-code in diezelfde mail te scannen met je bank-app. Plaatsen worden bekendgemaakt
              na toewijzing; de organisatie streeft ernaar de gewenste zone toe te wijzen maar kan dit niet
              garanderen.
            </p>
            <p className="mt-3">
              De organisatie heeft het recht inschrijvingen te weigeren of kandidaat-standhouders de toegang
              tot de rommelmarkt te ontzeggen, in het belang van de rommelmarkt of de veiligheid.
            </p>
          </Artikel>

          <Artikel n={5} titel="Wat mag er verkocht worden?">
            <p>
              De rommelmarkt is uitsluitend bedoeld voor particulieren, niet voor professionele verkopers.
              Enkel tweedehands spullen mogen worden verkocht; nieuwe producten zijn verboden.
            </p>
            <p className="mt-3">
              Worden elektrische apparaten aangeboden, dan zijn de koper en de verkopende standhouder zelf
              verantwoordelijk voor die apparaten. De organisatie kan niet gevraagd worden ze te testen.
            </p>
            <p className="mt-3">
              Verkoop van voedsel en drank is voorbehouden aan de organisatie.
            </p>
          </Artikel>

          <Artikel n={6} titel="Tijdstabel op de dag zelf">
            <ul className="space-y-2 list-none">
              <li><span className="font-display tracking-display uppercase text-ink/60 mr-2">Vanaf 07u</span> Standhouders mogen hun stand opzetten.</li>
              <li><span className="font-display tracking-display uppercase text-ink/60 mr-2">Ten laatste 09u</span> Al het gemotoriseerd verkeer van standhouders moet de marktzone verlaten hebben. Enkel de aangeduide ruimte mag worden ingenomen.</li>
              <li><span className="font-display tracking-display uppercase text-ink/60 mr-2">Vanaf 17u</span> De stand mag worden afgebroken en opgeruimd. Eerder afbreken is niet toegestaan.</li>
            </ul>
          </Artikel>

          <Artikel n={7} titel="Veiligheid en doorgang">
            <p>
              Standhouders houden de rijbaan te allen tijde vrij: een doorgangsruimte van minimaal{' '}
              <strong>4 meter breed</strong> (6 meter in bochten) en <strong>4 meter hoog</strong> moet
              gegarandeerd zijn voor hulp- en veiligheidsdiensten. Omliggende gebouwen, hydranten en
              gasafsluitingen moeten permanent bereikbaar en toegankelijk blijven voor de brandweer.
            </p>
            <p className="mt-3">
              Het is verboden voertuigen of aanhangwagens te stallen binnen de marktzone. Standhouders zijn
              zelf verantwoordelijk voor het veilig houden van hun stand en omgeving.
            </p>
          </Artikel>

          <Artikel n={8} titel="Opruimen">
            Elke standhouder ruimt na afloop zijn stand op en laat de plek achter zoals voor aanvang. Niets
            mag achterblijven op de openbare weg. De vuilbakken in de straten zijn niet bedoeld voor afval
            of waardeloos geworden materiaal van de stand — dit achterlaten wordt beschouwd als sluikstorten,
            wat een misdrijf is. Standhouders wijzen mede-standhouders zo nodig op hun opruimingsplicht.
          </Artikel>

          <Artikel n={9} titel="Aansprakelijkheid">
            De organisatie is niet verantwoordelijk voor eventuele ongevallen, noch voor beschadiging,
            verlies of diefstal van eigendommen van standhouders of bezoekers. Standhouders nemen zelf de
            nodige maatregelen om diefstal te voorkomen, zoals het bij de hand houden van waardevolle
            spullen en betalingen.
          </Artikel>

          <Artikel n={10} titel="Privacy (GDPR)">
            Persoonsgegevens worden uitsluitend gebruikt voor intern gebruik en voor een vlotte communicatie
            en organisatie van de rommelmarkt, conform de wetgeving op de bescherming van persoonsgegevens.
          </Artikel>
        </div>
      </section>

      <section className="bg-ink text-lime border-b-[3px] border-ink">
        <div className="mx-auto max-w-5xl px-5 py-12 flex flex-col sm:flex-row gap-4 items-center justify-between">
          <p className="font-display text-3xl sm:text-4xl tracking-display uppercase">Klaar om mee te doen?</p>
          <Link to="/inschrijven">
            <BigButton variant="lime">Schrijf je nu in</BigButton>
          </Link>
        </div>
      </section>
    </>
  )
}

function Artikel({ n, titel, children }: { n: number; titel: string; children: React.ReactNode }) {
  return (
    <article className="grid sm:grid-cols-[6rem_1fr] gap-4 border-b-[3px] border-ink/10 pb-10 last:border-0 last:pb-0">
      <div className="font-display text-3xl tracking-display uppercase text-ink/30 pt-1">
        {n.toString().padStart(2, '0')}.
      </div>
      <div>
        <h2 className="font-display text-2xl tracking-display uppercase mb-3">{titel}</h2>
        <div className="text-base leading-relaxed text-ink/80">{children}</div>
      </div>
    </article>
  )
}
